import SecureLS from 'secure-ls';

const ls = new SecureLS({ isCompression: false });

export default class TokenStorage {
  /**
   * Function used to get token
   * @returns {string} - token
   */
  static getToken() {
    return ls.get('token');
  }

  /**
   * Function used to get refresh token
   * @returns {string} - refresh token
   */
  static getRefreshToken() {
    return ls.get('refreshToken');
  }

  /**
   * Function used to set token
   * @param {*} token - token to be stored
   */
  static setToken(token) {
    ls.set('token', token);
  }

  /**
   * Function used to remove token
   */
  static removeToken() {
    ls.remove('token');
  }
  /**
   * Function used to remove refresh token
   */
  static removeRefreshToken() {
    ls.remove('refreshToken');
  }

  /**
   * Function used to set refresh token
   * @param {*} token - refresh token to be stored
   */
  static setRefreshToken(token) {
    ls.set('refreshToken', token);
  }
}
